export enum TimeZone {
  Central = 'America/Chicago',
}
